import {
  getProfGroups,
  getProfGroupsDetail,
} from "@/core/api/requests/getProfGroups";
import { atom, batch, onConnect, reatomAsync } from "@reatom/framework";
import { withSessionStorage } from "@reatom/persist-web-storage";
import { selectedCategoriesAtom } from "../search";
import { ProfGroupDetailInterface, ProfGroupInterface } from "./types";

export const profGroupAtom = atom<ProfGroupInterface[] | null>(
  null,
  "profGroupAtom"
).pipe(withSessionStorage("profGroup"));

export const profGroupDetailAtom = atom<ProfGroupDetailInterface[]>(
  [],
  "profGroupDetailAtom"
).pipe(withSessionStorage("profGroupDetails"));

export const currentSubCategories = atom<ProfGroupDetailInterface[] | null>(
  (ctx) => {
    const selected = ctx.spy(selectedCategoriesAtom);

    if (!selected?.length) return null;

    const profGroupDetail = ctx.spy(profGroupDetailAtom);
    const filtered = profGroupDetail?.filter((detail) =>
      selected.some((cat) => cat.id === detail.prof_group.id)
    );

    return filtered;
  },
  "currentSubCategories"
);

export const isLoadingAtom = atom(false, "isLoadingAtom");

export const fetchProfGroup = reatomAsync(
  async (ctx) => ctx.schedule(getProfGroups),
  {
    name: "fetchProfGroup",
    onFulfill: (ctx, data) => {
      if (data?.length) profGroupAtom(ctx, data);
    },
  }
);

export const fetchProfGroupDetail = reatomAsync(
  async (ctx) => {
    if (ctx.get(selectedCategoriesAtom)) {
      isLoadingAtom(ctx, true);
      return ctx.schedule(getProfGroupsDetail);
    }
  },
  {
    name: "fetchProfGroupDetail",
    onFulfill: (ctx, data) => {
      if (data?.length) {
        batch(ctx, () => {
          profGroupDetailAtom(ctx, data);
          isLoadingAtom(ctx, false);
        });
      }
    },
  }
);

onConnect(profGroupAtom, (ctx) => {
  if (!ctx.get(profGroupAtom)?.length) fetchProfGroup(ctx);
});

onConnect(profGroupDetailAtom, (ctx) => {
  if (!ctx.get(profGroupDetailAtom)?.length) fetchProfGroupDetail(ctx);
});
